import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Modal from '@mui/material/Modal';
import { useTranslation } from 'react-i18next';

import { MatchModeConfig } from './matchConfig';

/**
 * The blue-headed card both flag modals sit in. Styled here rather than through
 * BaseModal: that one is a black-bordered utility shell, and this wants the
 * game's own colour.
 */
export const ItemModalShell = ({
  config,
  open,
  onClose,
  flagUrl,
  onImageError,
  children,
}: {
  config: MatchModeConfig;
  open: boolean;
  onClose: () => void;
  flagUrl: string;
  onImageError?: () => void;
  children: React.ReactNode;
}) => {
  const { t } = useTranslation();
  const i18nBase = config.i18nBase;

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-label={t(`${i18nBase}.title`)}
      sx={{ zIndex: 10000 }}
    >
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] max-w-[26rem] overflow-hidden rounded-2xl bg-white shadow-2xl outline-none dark:bg-slate-800 dark:text-white">
        <div className="flex items-center justify-between px-4 py-2.5 bg-[#1a76d2] text-white">
          <span className="text-sm font-bold uppercase tracking-[0.08em]">
            {t(`${i18nBase}.title`)}
          </span>
          <button
            type="button"
            onClick={onClose}
            aria-label={t('header.menu.close')}
            className="flex w-7 h-7 items-center justify-center rounded-full text-white/80 transition-colors hover:bg-white/20 hover:text-white"
          >
            <CloseRoundedIcon fontSize="small" />
          </button>
        </div>

        <div className="flex flex-col p-4 gap-4 items-center">
          <img
            src={flagUrl}
            alt=""
            onError={onImageError}
            className="w-full max-w-[20rem] max-h-[42vh] object-contain rounded-xl border border-gray-200 shadow-sm dark:border-slate-600"
          />
          {children}
        </div>
      </div>
    </Modal>
  );
};
